export const getTaxes = (productsCost: number = 0) => {
  if (productsCost > 0) {
    const taxValue = (3.5 * productsCost) / 100;
    return taxValue;
  }
  return 0;
};
